define('../app/fukit/model/active.product.model',['require','exports','module','./admin.base.model'],function(require, exports, module) {
  //prettier-ignore
  var AdminBaseModel = require('./admin.base.model');

  var ActiveProductModel = AdminBaseModel.extend({
    radioRequests: { 'models ActiveProductModel': '@constructor' },

    urlRoot: AdminBaseModel.prototype.baseUrlRoot + '/tenant/product',
  });

  module.exports = ActiveProductModel;
});

